module.exports = __webpack_public_path__ + "static/media/tiktok.415a7134.jpg";